import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Newspaper } from 'lucide-react';
import { blogList } from '../api';

const CATS=['All','Law Updates','Guides','Labor Law','Business','Tax Law','Property'];

export default function Blog() {
  const [arts,setArts]   = useState([]);
  const [cat,setCat]     = useState('All');
  const [loading,setLoad]= useState(true);

  useEffect(()=>{
    setLoad(true);
    blogList(cat==='All'?'':cat).then(r=>setArts(r.data.articles||[])).catch(()=>{}).finally(()=>setLoad(false));
  },[cat]);

  return(
    <div className="max-w-5xl mx-auto px-6 py-8">
      <div className="text-center mb-10"><h1 className="text-3xl font-bold text-blue-950 mb-2">News & Articles</h1><p className="text-gray-400">Stay updated with the latest Cambodian law news, guides, and insights</p></div>
      <div className="flex flex-wrap gap-2 justify-center mb-10">
        {CATS.map(c=><button key={c} onClick={()=>setCat(c)} className={"text-sm px-4 py-1.5 rounded-full border transition "+(cat===c?'bg-blue-900 text-white border-blue-900':'border-gray-200 text-gray-600 hover:border-blue-300')}>{c}</button>)}
      </div>
      {loading?<div className="text-center py-20 text-gray-400">Loading articles...</div>
      :arts.length===0?<div className="text-center py-20 text-gray-400"><Newspaper size={48} className="mx-auto mb-3 opacity-20"/><p>No articles in this category</p></div>
      :<div className="grid md:grid-cols-3 gap-6">
        {arts.map(a=>(
          <Link key={a.id} to={`/blog/${a.slug}`} className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden hover:shadow-md transition group block">
            <div className="bg-gradient-to-br from-blue-900 to-blue-700 h-32 flex items-center justify-center text-5xl">{a.emoji||'📰'}</div>
            <div className="p-5">
              <span className="text-xs bg-blue-100 text-blue-700 px-2 py-0.5 rounded-full font-medium">{a.category}</span>
              <h3 className="font-bold text-gray-800 mt-2 mb-2 leading-snug group-hover:text-blue-700 transition">{a.title}</h3>
              <p className="text-sm text-gray-500 mb-3 line-clamp-2">{a.excerpt}</p>
              <div className="flex items-center justify-between text-xs text-gray-400">
                <span>{a.author}</span>
                <span>{a.published_at?new Date(a.published_at).toLocaleDateString():''}</span>
              </div>
            </div>
          </Link>
        ))}
      </div>}
    </div>
  );
}
